<div class="top__navbar"  [ngClass]="{ disabled: block }">
  <div class="container__custom">
    <div style="width: 150px;">
      OnDRM
      <strong _ngcontent-hmd-c33=""
        >Console<span style="font-size: 8px;"> v{{drmDetails.version? drmDetails.version : '0.0.0'}}</span></strong
      >
    </div>
    <div class="button__class">
      <!-- <button class="navButton" [routerLink]="['dashboard']">Dashboard</button> -->
      <button class="show__mobile" (click)="mobileMenu()">
        <img src="./assets/circle-menu.svg" alt="" />
      </button>
    </div>
    <ul *ngIf="showMobileFlag">
      <li [routerLink]="['sms']" [routerLinkActive]="['active']">
        <div class="logs">
          <span (click)="openMenu('sms')">SMS</span>
        </div>
      </li>
      <li [routerLink]="['stb']" [routerLinkActive]="['active']">
        <div class="logs">
          <span (click)="openMenu('stb')">STB</span>
        </div>
      </li>
      <li [routerLink]="['licence-logs']" [routerLinkActive]="['active']">
        <div class="logs">
          <span (click)="openMenu('channels')">License Request Logs</span>
        </div>
      </li>
      <li [routerLinkActive]="['active']">
        <div class="reports">
          <span (click)="openMenu('reports')">Reports</span>
          <div
            class="submenu--options"
            [ngClass]="{'opened':reportFlag}"
            (click)="reportFlag=!reportFlag"
          >
            <ul>
              <li
                [routerLink]="['trai-reports']"
                [routerLinkActive]="['active__link']"
              >
                TRAI
              </li>
            </ul>
          </div>
        </div>
      </li>

      <li [routerLink]="['logs/']" [routerLinkActive]="['active']">
        <div class="logs">
          <span (click)="openMenu('logs')">Logs</span>
          <!-- <div class="submenu--options" [ngClass]="{'opened':logFlag}" (click)="logFlag=!logFlag">
            <ul>
              <li [routerLink]="['logs/logs-complete']">Complete Logs</li>
              <li [routerLink]="['logs/logs-activation-deactivation']">STB Activation Deactivation Logs</li>
              <li [routerLink]="['logs/logs-subscriber-activation-deactivation']">Subscriber Activation Deactivation Logs</li>
              <li [routerLink]="['logs/logs-bouquet-subs-desubs']">Bouquet Subscription Desubscription Logs</li>
              <li [routerLink]="['logs/logs-channel-subs-desubs']">AlaCarte Subscription Desubscription Logs</li>
              <li [routerLink]="['logs/logs-bouquet-modification']">Bouquet Modification Logs</li>
              <li [routerLink]="['logs/logs-channel-modification']">Channel Modification Logs</li>
              <li [routerLink]="['logs/logs-alacarte-modification']">Ala Carte Modification Logs</li>
            </ul>
          </div> -->
        </div>
      </li>
      <li>
        <div class="profile">
          <img
            (click)="openMenu('profile')"
            class="hide__mobile"
            src="./assets/profile.svg"
          /><span class="show__mobile" (click)="openMenu('profile')"
            >Profile</span
          >
          <div
            class="submenu--options"
            [ngClass]="{'opened':profileFlag}"
            (click)="profileFlag=!profileFlag"
          >
            <ul>
              <li
                [routerLink]='["profile"]'
                [routerLinkActive]="['active__link']"
              >
                My Profile
              </li>
              <li
                [routerLink]='["crypto-period"]'
                [routerLinkActive]="['active__link']"
              >
             Crypto period
              </li>
              <li *ngIf="role=='superAdmin'" [routerLink]='["Admins"]' [routerLinkActive]="['active__link']"> 
                Add Admins
              </li>
              <li [routerLink]='["change-password"]' [routerLinkActive]="['active__link']">
                Change Password
              </li>
              <li (click)="logout()">Logout</li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
